export default __webpack_public_path__ + "static/media/adi-m.41a20e1f.jpg";